export default "__VITE_ASSET__51f8e3b3__"